import * as PropTypes from 'prop-types';
import { allowNull } from '../../helpers/propType.helper';
export var fieldBasePropTypes = {
  'data-id': PropTypes.string,
  error: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  stateReducer: PropTypes.func.isRequired,
  touched: allowNull(PropTypes.bool),
  value: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  children: PropTypes.func.isRequired
};